<template>
	<view class="sidebar">
		<view class="item" @click="handleUserInfo()">
			<view class="icon userInfo"></view>
			<view class="desc">个人中心</view>
		</view>
		<view class="item" @click="handleDownload()">
			<view class="icon app"></view>
			<view class="desc">App下载</view>
		</view>
		<view class="item" @click="handleService()">
			<view class="icon consult"></view>
			<view class="desc">我要咨询</view>
		</view>
		<view class="item" @click="toTop()">
			<view class="icon back"></view>
			<view class="desc">回到顶端</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				isToken: this.$store.state.token ? true : false,
				userId: this.$store.state.userId
			}
		},
		methods: {
			//回到顶部
			toTop() {
				// console.log('111')
				uni.pageScrollTo({
					scrollTop: 0,
					duration: 300
				});
			},
			//跳转至下载页
			handleDownload() {
				uni.navigateTo({
					url: '/pages/download/index'
				});
			},
			//跳转至个人中心模块
			handleUserInfo() {
				if (this.isToken) {
					if (!location.hash.includes('myOrder')) {
						uni.navigateTo({
							// url: '/pages/userInfo/myOrder/index?userId=' + this.userId
							url: '/pages/userInfo/myOrder/index'
						});
					}
				} else {
					uni.navigateTo({
						url: '/pages/login/loginpage/index'
					});
				}
			},
			//跳转七鱼平台
			handleService() {
				if (this.isToken) {
				
					let dev_pro = process.env.NODE_ENV; //获取环境变量
					let url;

					if (dev_pro == 'development') {
						url = this.baseURL + '/rjdd/#/pages/consult/index'; //本地环境
					} else {
						if (location.hostname.indexOf('dianducs') >= 0) {
							url = this.baseURL + '/rjdd/#/pages/consult/index'; //测试环境
						} else {
							url = this.baseURL + '/dist/#/pages/consult/index'; //正式环境
						}
					}

					window.open(url, '_blank');
				} else {
					uni.navigateTo({
						url: '/pages/login/loginpage/index'
					});
				}
			},
			//获取地址栏参数信息
			getParams() {
				let obj = {};
				let href = window.location.href;

				if (href.includes('?')) {
					let args = href.split('?');

					if (args[0] == href) { //没有传参
						return;
					}

					let arr = args[1].split('&');
					for (var i = 0; i < arr.length; i++) {
						let arg = arr[i].split('=');
						obj[arg[0]] = arg[1];
					}
				}

				return obj;
			},

		}
	}
</script>

<style lang="scss" scoped scoped>
	@import "@/style/components/sidebar.scss"; //引入样式文件
</style>
